import React from 'react';
import { PlusIcon, X } from 'lucide-react';
import { format, isBefore, startOfDay } from 'date-fns';
import { Commitment } from './CommitmentCalendar';
import { Button } from '@/components/ui/button';
import { ReactComponent as NoCommitmentsIcon } from '@/assets/icons/no-commitment.svg';
import { ReactComponent as CommitmentIcon } from '@/assets/icons/commitment-primary.svg';

interface CommitmentSidebarProps {
  date: Date;
  commitments: Commitment[];
  onClose: () => void;
  onCreateCommitment?: () => void;
}

const CommitmentSidebar = ({ date, commitments, onClose, onCreateCommitment }: CommitmentSidebarProps) => {
  const hasCommitments = commitments.length > 0;
  const isPastSelectedDate = isBefore(startOfDay(date), startOfDay(new Date()));

  return (
    <aside className="hidden md:flex w-[360px] min-w-[360px] h-full min-h-fit shrink-0 flex-col border bg-white p-4 rounded-[16px]">
      <header className="flex items-center justify-between pb-4">
        <p className="font-semibold text-lg">{format(date, 'MMM d')}</p>
        <button type="button" onClick={onClose} className="hover:opacity-70 transition-opacity">
          <X className="w-[22px] h-[22px] text-[#495057]" />
        </button>
      </header>

      {hasCommitments ? (
        <div className="flex flex-col py-2">
          {commitments.map((commitment) => (
            <div key={commitment.id} className="flex items-center gap-3 py-2.5 ">
              <div className="bg-lightPurple h-10 w-10 flex items-center justify-center rounded-full p-2">
                <CommitmentIcon className="w-5 h-5 text-primary" />
              </div>
              <div className="flex flex-col min-w-0">
                <span className="font-semibold text-sm truncate">{commitment.title}</span>
                {commitment.budgetName && (
                  <span className="text-xs text-muted-foreground truncate">{commitment.budgetName}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center flex-1 gap-0 py-10 px-6">
          <div className="flex items-center gap-3">
            <NoCommitmentsIcon className="w-14 h-14" />
            <div>
              <p className="text-sm font-semibold">No Commitment on this day</p>
              <p className="text-xs text-secondary font-medium">Create a new commitment to make thing on time!</p>
            </div>
          </div>
          {!isPastSelectedDate && (
            <Button
              variant="primary-reverse"
              onClick={onCreateCommitment}
              className="rounded-full flex items-center font-semibold text-sm gap-1.5 px-6 mt-4"
            >
              <span>Create a Commitment</span>
            </Button>
          )}
        </div>
      )}
    </aside>
  );
};

export default CommitmentSidebar;
